import React from 'react';
import Button from '../../button';
import useLayersStore from '../../stores/layersStore';

function CenterButton() {
  const fitScene = useLayersStore((state) => state.fitScene);
  const featureEnabled = useLayersStore((state) => state.featureEnabled);
  if (featureEnabled.centerModel) {
    return (
      <Button className="h-min" onClick={fitScene}>
        <div className='hidden sm:block'>Center Camera</div>
        <div className="sm:hidden">Recenter</div>
      </Button>
    );
  }
  return null;
}

export default CenterButton; 